import { EMPTY_VALUE } from '../../../utils/common'

export const covertPointRange = (data) => {
  const arr = data.map((item) => item.scoreRange_Min).sort()
  arr.shift()
  return [0, ...arr, 100]
}

export const handleModelList = (data) => {
  return {
    creditRiskDescription: data[0]?.modelDescription || EMPTY_VALUE,
    performanceDescription: data[1]?.modelDescription || EMPTY_VALUE,
  }
}
